import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import TopAppBar from '../../components/feature/TopAppBar';
import BottomTabBar from '../../components/feature/BottomTabBar';
import JobCard from '../../components/cards/JobCard';

export default function Jobs() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [filter, setFilter] = useState<'nearby' | 'highest' | 'earliest'>('nearby');
  const [isOnline, setIsOnline] = useState(true);
  
  const jobs = [
    {
      orderId: 'DOM2847',
      branchName: 'Domino\'s Stockholm City',
      distance: '2.4 km',
      eta: '9 min',
      payout: '89',
      status: 'ready' as const,
      pickupTime: '18:45',
      paymentType: 'Kort',
    },
    {
      orderId: 'DOM2848',
      branchName: 'Domino\'s Södermalm',
      distance: '3.1 km',
      eta: '12 min',
      payout: '95',
      status: 'preparing' as const,
      pickupTime: '19:00',
      paymentType: 'Kontant',
    },
    {
      orderId: 'DOM2849',
      branchName: 'Domino\'s Vasastan',
      distance: '1.8 km',
      eta: '7 min',
      payout: '82',
      status: 'ready' as const,
      pickupTime: '18:50',
      paymentType: 'Kort',
    },
    {
      orderId: 'DOM2850',
      branchName: 'Domino\'s Östermalm',
      distance: '4.2 km',
      eta: '15 min',
      payout: '105',
      status: 'new' as const,
      pickupTime: '19:15',
      paymentType: 'Swish',
    },
    {
      orderId: 'DOM2851',
      branchName: 'Domino\'s Kungsholmen',
      distance: '2.9 km',
      eta: '11 min',
      payout: '92',
      status: 'preparing' as const,
      pickupTime: '19:05',
      paymentType: 'Kort',
    },
  ];
  
  const filters = [
    { id: 'nearby', label: t('nearest') },
    { id: 'highest', label: t('highestPay') },
    { id: 'earliest', label: t('earliest') },
  ];
  
  return (
    <div className="min-h-screen bg-gray-50 pb-20">
      <TopAppBar title={t('availableJobs')} />
      
      <div className="pt-14 px-4">
        <div className="bg-white rounded-2xl p-4 shadow-md mb-4 mt-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-3">
              <div className={`w-3 h-3 rounded-full ${isOnline ? 'bg-green-500' : 'bg-gray-400'} animate-pulse`}></div>
              <div>
                <p className="text-sm font-bold text-gray-900">
                  {isOnline ? t('online') : t('offline')}
                </p>
                <p className="text-xs text-gray-600">
                  {isOnline ? t('readyToReceiveOrders') : t('notReceivingOrders')}
                </p>
              </div>
            </div>
            <button
              onClick={() => setIsOnline(!isOnline)}
              className="relative w-14 h-8 rounded-full transition-colors"
              style={{ backgroundColor: isOnline ? '#10B981' : '#D1D5DB' }}
            >
              <div
                className={`absolute top-1 w-6 h-6 bg-white rounded-full shadow-md transition-transform ${
                  isOnline ? 'translate-x-7' : 'translate-x-1'
                }`}
              ></div>
            </button>
          </div>
        </div>
        
        <div className="flex gap-2 mb-4 overflow-x-auto pb-2">
          {filters.map((f) => (
            <button
              key={f.id}
              onClick={() => setFilter(f.id as typeof filter)}
              className={`px-4 py-2 rounded-full text-sm font-semibold whitespace-nowrap transition-all ${
                filter === f.id
                  ? 'bg-[#E31837] text-white'
                  : 'bg-white text-gray-700 border border-gray-200'
              }`}
            >
              {f.label}
            </button>
          ))}
        </div>
        
        <div className="mb-3">
          <p className="text-sm font-semibold text-gray-700">
            {jobs.length} {t('availableDeliveries')}
          </p>
        </div>
        
        <div className="space-y-3">
          {jobs.map((job) => (
            <JobCard
              key={job.orderId}
              {...job}
              onClick={() => navigate(`/job/${job.orderId}`)}
            />
          ))}
        </div>
      </div>
      
      <BottomTabBar />
    </div>
  );
}
